import React, {FC, memo, useEffect} from "react";
import {actions as actionModal} from "../../store/sliceModal";
import {actions as actionApp} from "../../store/sliceApp";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {PageCamerasArticle, PageCamerasContainer, PageCamerasText} from "./PageCamerasStyle";
import cameraIcon from "../../image/camera.png";


const PageCameras: FC = () => {
    const dispatch = useDispatch<AppDispatch>();


    useEffect(() => {
        dispatch(actionApp.setCameras())

    }, [])
    return (
        <PageCamerasContainer>
            <h1>Домашние камеры</h1>
            {/*<video src={media} autoPlay={true}></video>*/}
            <div style={{display: "flex"}}>
                <PageCamerasArticle onClick={() => dispatch(actionModal.showCameraModal({title: "Камера", urlName: "cam1"}))}>
                    <img style={{width: "100px"}} src={cameraIcon} alt={"camera"}/>
                    <PageCamerasText>Камера</PageCamerasText>
                </PageCamerasArticle>
            </div>

        </PageCamerasContainer>
    )
}

export default memo(PageCameras)
